export const PINCODE_ENDPOINT = '/physical-store/store-and-tahhub-details';